<div class="modal wrapper" id="withdrawModal" [style.display]="isWithdeawVisible ? 'flex' : 'none'">
    <div class="modal-block top-up-auto">
        <div class="title">
            <h2>
                Withdraw balance
                <!-- <?php echo languageDetector('سحب الرصيد', 'Withdraw balance'); ?> -->
            </h2>
            <button class="btn close" (click)="closeWithdrawModal()">
                <img src="./images/delivery-wallet/x-close.svg" alt="close" loading="lazy">
            </button>
        </div>
        <form class="modal-inner" (ngSubmit)="onSubmit()">
            <div class="col amount">
                <div class="select-value">
                    <label for="amount">
                        Select amount
                    </label>
                    <div class="row">
                        <div 
                            *ngFor="let item of amounts" 
                            class="select-item" 
                            [ngClass]="{ 'active': selectedItem?.amount === item.amount && selectedItem?.charge_id === item.charge_id }"
                            (click)="setActive(item)">
                            {{ item.amount }}
                        </div>
                    </div>
                </div>

              
            </div>
            
            <button class="btn md" type="submit">
                Continue
                <!-- <?php echo languageDetector('إضافة المبلغ لرصيد التوصيل', 'Continue'); ?> -->
            </button>
        </form>
    </div>
</div>